"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const arrayMaker_1 = __importStar(require("../../../../Util/arrayMaker"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const getIsTrainingDoneIterator_1 = __importDefault(require("../Maker/getIsTrainingDoneIterator"));
const getRateIterator_1 = __importDefault(require("../Maker/getRateIterator"));
const getExercisesAmountIterator_1 = __importDefault(require("../Maker/getExercisesAmountIterator"));
const getExerciseNameIterator_1 = __importDefault(require("../Maker/getExerciseNameIterator"));
const translateRating_1 = __importDefault(require("./translateRating"));
const getSetsAmountIterator_1 = __importDefault(require("../Maker/getSetsAmountIterator"));
const getHasNoteIterator_1 = __importDefault(require("../Maker/getHasNoteIterator"));
const getNoteIterator_1 = __importDefault(require("../Maker/getNoteIterator"));
class TrainingInitializer extends AbstractInitializer_1.default {
    constructor(cache, trainingModel, customerRepository, dateTimeProvider, dateTimeModifier) {
        super("training_initializer", cache);
        this.initialize = async () => {
            const currentDate = this.dateTimeProvider.currentDate();
            const isTrainingDoneIterator = (0, getIsTrainingDoneIterator_1.default)();
            const rateIterator = (0, getRateIterator_1.default)();
            const exercisesAmount = (0, getExercisesAmountIterator_1.default)();
            const exerciseNameIterator = (0, getExerciseNameIterator_1.default)();
            const setsAmountIterator = (0, getSetsAmountIterator_1.default)();
            const hasNoteIterator = (0, getHasNoteIterator_1.default)();
            const noteIterator = (0, getNoteIterator_1.default)();
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                const exerciseProgressions = {};
                const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                const trainingDays = await (0, arrayMaker_1.asyncArrayMaker)(daysDiff, async (index) => {
                    const date = await this.dateTimeProvider.fromDateTimeToDate(this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, index));
                    const isDone = isTrainingDoneIterator.next();
                    return {
                        date,
                        training: {
                            isDone,
                            rate: isDone ? rateIterator.next() : null,
                            exercises: (0, arrayMaker_1.default)(isDone === null ? 0 : exercisesAmount.next(), () => {
                                const exerciseName = exerciseNameIterator.next();
                                const id = exerciseName;
                                if (exerciseProgressions[id] === undefined) {
                                    exerciseProgressions[id] = [];
                                }
                                const note = {
                                    body: hasNoteIterator.next() ? noteIterator.next() : "",
                                };
                                const exercise = {
                                    id,
                                    name: exerciseName,
                                    guidelines: "4 series van 12-15 herhalingen",
                                    rest: "5 sec",
                                    rating: isDone
                                        ? (0, translateRating_1.default)(rateIterator.next())
                                        : null,
                                    // type-coverage:ignore-next-line
                                    historyOfProgress: JSON.parse(JSON.stringify(exerciseProgressions[exerciseName])),
                                    sets: new Array(setsAmountIterator.next())
                                        .fill(null)
                                        .map((_ignored, ordinalNumber) => {
                                        return {
                                            ordinalNumber: ordinalNumber + 1,
                                            weight: 20.5,
                                            repetitions: 10,
                                        };
                                    }),
                                    seriesData: [],
                                    image: "https://picsum.photos/200/300",
                                    note,
                                    group: 1,
                                };
                                exerciseProgressions[exerciseName].push({
                                    date,
                                    sets: exercise.sets,
                                });
                                return exercise;
                            }),
                        },
                    };
                });
                await this.trainingModel.addTrainings(customer.id, trainingDays);
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.trainingModel = trainingModel;
        this.customerRepository = customerRepository;
    }
}
exports.default = TrainingInitializer;
//# sourceMappingURL=TrainingInitializer.js.map